import React, { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

export interface BodyProps {
  /**
   * The content of the component.
   */
  children?: React.ReactNode;

  /**
   * @ignore
   * Classes applied to the root element.
   */
  className?: string;
}

const Body = forwardRef(
  ({ children, className }: BodyProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div className={classNames('ds-card__body', className)} ref={ref}>
        {children}
      </div>
    );
  },
);

export default Body;
